// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__k0Ay3","h1":"Heading_h1__y10HP","h3":"Heading_h3__kyiHg"};